
import { Droplets, Footprints, Moon, Brain, Utensils, Book, Dumbbell, Heart, Smile, Coffee } from 'lucide-react';

export const ICON_MAP = {
    Droplets, Footprints, Moon, Brain, Utensils, Book, Dumbbell, Heart, Smile, Coffee
};

export const SUGGESTED_HABITS = [
    // Saúde
    { name: 'Beber Água', category: 'Saúde', icon: 'Droplets', color: '#4ECDC4', target: 2000, unit: 'ml' },
    { name: 'Vitaminas', category: 'Saúde', icon: 'Heart', color: '#FF6B6B', target: 1, unit: 'vezes' },
    { name: 'Dormir Cedo', category: 'Saúde', icon: 'Moon', color: '#95A6F8', target: 8, unit: 'horas' },

    // Movimento
    { name: 'Caminhar', category: 'Movimento', icon: 'Footprints', color: '#FFB088', target: 10000, unit: 'passos' },
    { name: 'Exercício', category: 'Movimento', icon: 'Dumbbell', color: '#FF9F43', target: 30, unit: 'min' },
    { name: 'Alongamento', category: 'Movimento', icon: 'Dumbbell', color: '#A29BFE', target: 15, unit: 'min' },
    { name: 'Yoga', category: 'Movimento', icon: 'Dumbbell', color: '#74B9FF', target: 20, unit: 'min' },

    // Mente
    { name: 'Meditação', category: 'Mente', icon: 'Brain', color: '#7BC9A6', target: 10, unit: 'min' },
    { name: 'Leitura', category: 'Mente', icon: 'Book', color: '#74C0FC', target: 30, unit: 'min' },
    { name: 'Journaling', category: 'Mente', icon: 'Book', color: '#DDA15E', target: 10, unit: 'min' },
    { name: 'Podcast', category: 'Mente', icon: 'Brain', color: '#FAA2C1', target: 20, unit: 'min' },
    { name: 'Estudo', category: 'Mente', icon: 'Book', color: '#5F27CD', target: 60, unit: 'min' },

    // Alimentação
    { name: 'Café da Manhã', category: 'Alimentação', icon: 'Coffee', color: '#8D6E63', target: 1, unit: 'refeições' },
    { name: 'Frutas e Vegetais', category: 'Alimentação', icon: 'Utensils', color: '#4CAF50', target: 5, unit: 'porções' },
    { name: 'Evitar Açúcar', category: 'Alimentação', icon: 'Utensils', color: '#E74C3C', target: 1, unit: 'vezes' },
    { name: 'Cozinhar em Casa', category: 'Alimentação', icon: 'Utensils', color: '#16A085', target: 1, unit: 'refeições' },

    // Produtividade
    { name: 'Deep Work', category: 'Produtividade', icon: 'Brain', color: '#1ABC9C', target: 90, unit: 'min' },
    { name: 'Sem Redes Sociais', category: 'Produtividade', icon: 'Smile', color: '#E67E22', target: 1, unit: 'vezes' },
    { name: 'Planejar o Dia', category: 'Produtividade', icon: 'Book', color: '#3498DB', target: 1, unit: 'vezes' },

    // Bem-estar
    { name: 'Gratidão', category: 'Bem-estar', icon: 'Smile', color: '#FD79A8', target: 3, unit: 'itens' },
    { name: 'Tempo ao Ar Livre', category: 'Bem-estar', icon: 'Footprints', color: '#55EFC4', target: 30, unit: 'min' },
    { name: 'Conversar com Amigos', category: 'Bem-estar', icon: 'Smile', color: '#FFA502', target: 1, unit: 'vezes' },
    { name: 'Banho Relaxante', category: 'Bem-estar', icon: 'Smile', color: '#5DADE2', target: 1, unit: 'vezes' },

    // Hábitos Digitais
    { name: 'Modo Avião (Noite)', category: 'Digital', icon: 'Moon', color: '#546E7A', target: 1, unit: 'vezes' },
    { name: 'Backup de Dados', category: 'Digital', icon: 'Brain', color: '#7F8C8D', target: 1, unit: 'vezes' },
];
